import image from "../../assets/pagebanner7.jpg";
import image1 from "../../assets/blog-01.jpg";
import image2 from "../../assets/blog-02.jpg";
import image3 from "../../assets/blog-03.jpg";
import image4 from "../../assets/product-min-01.jpg";
import image5 from "../../assets/product-min-02.jpg";
import image6 from "../../assets/product-min-03.jpg";

export const BANNER = [
  {
    img: image,
  },
];

export const BLOG = [
  {
    id: 1,
    image: image1,
    date: "22 July 2022",
    title: "Resident Evil Village DLC Winters’ Expansion launches October 28",
    detail:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique iste non dolores, est, laudantium perspiciatis sequi obcaecati assumenda omnis cum, dolore quisquam ullam impedit? Ducimus repudiandae sapiente nesciunt ea sunt tempora? Explicabo, culpa possimus repudiandae dicta vitae enim qui recusandae. Reiciendis dicta tempora obcaecati deserunt, quaerat impedit eligendi ipsam aperiam!",
  },
  {
    id: 2,
    image: image2,
    date: "22 July 2022",
    title: "The Witcher 3. Meaning of all this simbols",
    className: "image2",
    detail:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique iste non dolores, est, laudantium perspiciatis sequi obcaecati assumenda omnis cum, dolore quisquam ullam impedit? Ducimus repudiandae sapiente nesciunt ea sunt tempora? Explicabo, culpa possimus repudiandae dicta vitae enim qui recusandae. Reiciendis dicta tempora obcaecati deserunt, quaerat impedit eligendi ipsam aperiam!",
  },
  {
    id: 3,
    image: image3,
    date: "22 July 2022",
    title:
      "Players’ Choice: Final Fantasy VII Remake Voted April’s Best New Game",
    detail:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique iste non dolores, est, laudantium perspiciatis sequi obcaecati assumenda omnis cum, dolore quisquam ullam impedit? Ducimus repudiandae sapiente nesciunt ea sunt tempora? Explicabo, culpa possimus repudiandae dicta vitae enim qui recusandae. Reiciendis dicta tempora obcaecati deserunt, quaerat impedit eligendi ipsam aperiam!",
  },
];

export const CATEGORY = [
  {
    item: "Action & Adventure",
    to: "/adventure",
  },
  {
    item: "Sports",
    to: "/sports",
  },
  {
    item: "Kids and Family",
    to: "/kids",
  },
  {
    item: "RPG",
    to: "/homepage1",
  },
  {
    item: "Race",
    to: "/sports",
  },
];

export const RECOMMEND = [
  {
    img: image4,
    title: "Assasin's Creed III: Remastered",
    price: "$50.00",
  },
  {
    img: image5,
    title: "The Witcher 3: Wild Hunt",
    price: "$93.00",
  },
  {
    img: image6,
    title: "Resident Evil: Village",
    price: "$93.00",
  },
];

export const ARCHIVE = [
  {
    items: "July 2023",
    num: "(9)",
  },
  {
    items: "June 2023",
    num: "(39)",
  },
  {
    items: "May 2023",
    num: "(29)",
  },
  {
    items: "April 2023",
    num: "(35)",
  },
  {
    items: "March 2023",
    num: "(22)",
  },
  {
    items: "February",
    num: "(32)",
  },
  {
    items: "January",
    num: "(21)",
  },
  {
    items: "December 2023",
    num: "(26)",
  },
];

export const TAGS = [
  {
    item: "Action",
    to: "/adventure",
  },
  {
    item: "Adventure",
    to: "/adventure",
  },
  {
    item: "Sports",
    to: "/sports",
  },
  {
    item: "Race",
    to: "/sports",
  },
  {
    item: "Kids and Family",
    to: "/kids",
  },
];
